import styled from 'styled-components';
import { colorVariables, mediaTemplates } from 'theme/variables';

export const RateCardStyled = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  width: 100%;
  border: 1px solid ${colorVariables.white_verylightgainsboro};
  background-color: white;
  padding: 13px 16px;
  text-decoration: none;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 75ms ease-in;

  &:hover {
    border: 1px solid ${colorVariables.blue_navyblue};
    transition: 135ms ease-out;
  }

  &:last-child {
    margin-bottom: 0;
  }

  ${mediaTemplates.l} {
    height: 50px;
  }
`;

export const WrapperLeftPart = styled.div`
  position: relative;
`;

export const WrapperRightPart = styled.div`
  position: relative;
`;
